import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';
import styles from './Table.scss';
import iconLock from 'assets/images/icons/icon-lock.svg';
import { isReserved } from '../../../../helper';
import { gaEvent, trackGA } from 'services/ga';

const SPAN_PERCENT = 100;

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dragging: false,
      x: 0,
      y: 0,
      hoverId: null
    };
    this.handleCellClick = this.handleCellClick.bind(this);
  }

  componentDidMount() {
    const { defaultScroll } = this.props;
    const table = ReactDOM.findDOMNode(this);
    table.scrollTop = defaultScroll[0];
    table.scrollLeft = defaultScroll[1];

    document.addEventListener('mousemove', this.handleMouseMove, false);
    document.addEventListener('mouseup', this.handleMouseUp, false);
  }

  componentWillUnmount() {
    const { handleScroll } = this.props;
    const table = ReactDOM.findDOMNode(this);
    const { scrollTop, scrollLeft } = table;
    handleScroll(scrollTop, scrollLeft);

    document.removeEventListener('mousemove', this.handleMouseMove, false);
    document.removeEventListener('mouseup', this.handleMouseUp, false);
  }

  handleCellClick(row, column, cell) {
    const { handleCellClick } = this.props;
    this.handleTrackEvent({
      eventName: 'buildingChessLotClick',
      cell,
      eventContext: 'shahmatka'
    });
    handleCellClick([row, column]);
  }

  renderHeaderCells() {
    const { cols, page, pageSize } = this.props;
    return cols.map((column, index) => {
      if (!column) {
        return (
          <div key={index} className={cn(styles.CellMaster, styles.HeaderCell)} />
        );
      }

      let { colspan } = column;
      colspan = Number(colspan) || 1;
      const style = { width: `${colspan * SPAN_PERCENT}%` };
      return (
        <div key={index} className={cn(styles.CellMaster, styles.HeaderCell)}>
          <div className={styles.Stretch} style={style}>
            <div className={styles.CellContent}>
              <span>{column.name.length > 3 ? ((column.name[0] == 'К') ? column.name : column.name[0]) : column.name}</span>
            </div>
          </div>
        </div>
      );
    }).slice(page * pageSize, (page + 1) * pageSize);
  }

  renderRowNumCell(row) {
    return (
      <div className={cn(styles.CellMaster, styles.RowNumCell)}>
        <div className={styles.CellContent}>
          {row.name.length > 3 ? row.name[0] : row.name}
        </div>
      </div>
    );
  }

  renderFantomCell(col) {
    return (
      <div key={col} className={cn(styles.CellMaster, styles.Cell, styles.CellFantom)} />
    );
  }

  renderHiddenCell(col) {
    return (
      <div key={col} className={cn(styles.CellMaster, styles.Cell)}>
        <div className={cn(styles.CellContent, styles.Hidden)} />
      </div>
    );
  }

  handleTrackEvent = ({ eventName, cell, eventContext }) => {
    const { profile, objectType, building } = this.props;
    const { number, costFormatted, area, priceFormatted } = cell.data;
    const eventContent = `${number} | ${costFormatted} | ${area} | ${priceFormatted}`;

    trackGA(gaEvent[eventName]({
      eventContent,
      eventContext,
      productType: objectType,
      productName: building.title,
      productID: building.id,
      user_id: profile.id
    }));
  }

  renderCellContent(cell, stretched) {
    const { content, selected, print } = this.props;
    const { row, col } = cell;
    const isSelected = selected && selected[0] === row && selected[1] === col;
    const { content: { [content]: cellContent }, hidden } = cell;
    const reservation = isReserved(cell.data.status);
    const borderTop = cell.data.view_action === '1';/* isAction */
    const isFund = (cell.data.status === 'fundStatus');

    const hoverId = `cell-${cell.id}`;
    const handleMouseEnter = () => {
      this.setState({ hoverId });
      this.handleTrackEvent({
        eventName: 'buildingChessLotHover',
        cell
      });
    };
    const handleMouseLeave = () => this.setState({ hoverId: null });

    return (
      <div
        className={cn(
          styles.CellContent,
          styles.CellTooltip,
          {
            [styles.Selected]: isSelected,
            [styles.Hidden]: hidden
          },
          isFund ? (
              styles.Fund
            ) : (
          { [styles.Reservation]: reservation,
            [styles.BorderTop]: (borderTop && !hidden) }
            )
        )}
        onClick={this.handleCellClick.bind(undefined, row, col, cell)}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {(print && reservation) ?
            stretched ?
              <span className={cn(styles.PrintReservPattern, styles.Stretched)}><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></span>
                :
              <span className={styles.PrintReservPattern}><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></span>

            : null}
        {cell.data.status === 'fundStatus' ? (
          <span data-status={cell.data.status} data-area={cell.data.area}><img src={iconLock} alt="" /></span>
        ) : (
          <span data-status={cell.data.status} data-area={cell.data.area}>{cellContent}</span>
        )}
        {hoverId === this.state.hoverId && (!cell.hidden && !this.props.wide && !(cell.data.status === 'fundStatus') && (cell.data.costFormatted != 0)) && (
          <div className={cn(styles.CellTooltipText)} id={hoverId}>
            <div className={cn(styles.TooltipContent, { [styles.Action]: borderTop }, { [styles.Reserve]: reservation })}>
              <div className={styles.TooltipContentLeft}>
                <span className={styles.FlatNum}><span>№{cell.data.number}</span></span>
                <span><span>{cell.data.apartmentsName}</span></span>
              </div>
              <div className={styles.TooltipContentRight}>
                <span className={styles.Price}><span>{cell.data.costFormatted} </span></span>
                <span><span>{cell.data.area}, {cell.data.priceFormatted}</span></span>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderStretchedCell(cell) {
    const { col, colspan, rowspan, mark } = cell;
    let style;
    if (colspan || rowspan) {
      style = {};
      if (colspan > 1) {
        style.width = `${colspan * SPAN_PERCENT}%`;
      }
      if (rowspan > 1) {
        style.height = `${rowspan * SPAN_PERCENT}%`;
      }
    }
    return (
      <div key={col} className={cn(styles.CellMaster, { [styles.NotMatch]: !mark })}>
        <div className={cn(styles.Stretch, styles.Cell)} style={style}>
          {this.renderCellContent(cell, true)}
        </div>
      </div>
    );
  }

  renderCell(cell) {
    const { col, mark } = cell;
    return (
      <div key={col} className={cn(styles.CellMaster, styles.Cell, { [styles.NotMatch]: !mark })}>
        {this.renderCellContent(cell)}
      </div>
    );
  }

  renderRows() {
    const { data, rows, page, pageSize } = this.props;

    return rows.map((row, rowIndex) => (
      <div key={rowIndex} className={styles.Row}>
        { this.renderRowNumCell(row) }
        { data[rowIndex].cells
          .map((cell, columnIndex) => {
            if (cell == null) {
              return this.renderFantomCell(columnIndex);
            } else if (cell.colspan > 1 || cell.rowspan > 1) {
              return this.renderStretchedCell(cell);
            }
            return this.renderCell(cell);
          })
          .slice(page * pageSize, (page + 1) * pageSize)
        }
      </div>
    ));
  }

  handleMouseDown = (e) => {
    this.setState({ dragging: true });
    // Set coords
    this.coords = {
      x: e.pageX,
      y: e.pageY
    };
  }
  handleMouseUp = () => {
    this.setState({ dragging: false });
    this.coords = {};
  }
  handleMouseMove = (e) => {
    if (!this.state.dragging) {
      return;
    }
    e.preventDefault();
    this.handleMove(e);
  }
  handleMove = (e) => {
    this.setState({
      x: e.movementX,
      y: e.movementY
    });

    this.handleScroll();
  }
  handleScroll = () => {
    this.refs.table.scrollTop = this.refs.table.scrollTop - this.state.y;
    this.refs.table.scrollLeft = this.refs.table.scrollLeft - this.state.x;
  }

  render() {
    const { className, wide, rows, cols, print, zoom } = this.props;

    const zoomStyle = {
      transform: `scale(${zoom})`,
      position: 'relative',
      transformOrigin: '0 0'
    };

    return (
      <div
        onMouseDown={this.handleMouseDown}
        style={{
          cursor: this.state.dragging ? '-webkit-grabbing' : 'default'
        }}
        className={cn(styles.Table, 'custom-scrollbar', { [styles.TablePrint]: print }, className)}
        ref="table"
      >
        <div className={cn(styles.Inner, { [styles.Wide]: wide })} style={zoomStyle}>
          <div className={styles.Header}>
            {rows.length || cols.length ? (
              <div className={cn(styles.CellMaster, styles.Appendicitis)}>
                <div className={styles.CellContent} />
              </div>
            ) : null}
            {this.renderHeaderCells()}
          </div>
          <div className={styles.Data}>
            <div className={styles.Rows}>
              {this.renderRows()}
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// ./src/components/Building/Chess/Table/Table.js